// extracted by mini-css-extract-plugin
module.exports = {"header":"style__header__q4H0Z","logo":"style__logo__PgcIE"};